<script setup lang="ts">
import { ref } from 'vue';
import { Navigation, Thumbs } from 'swiper/modules';

const thumbsSwiper = ref(null);
const setThumbsSwiper = (swiper) => {
  thumbsSwiper.value = swiper;
};

const active = ref(false);
const opened = ref([]);

const toggle = (id) => {
  if (opened.value.includes(id)) {
    let index = opened.value.indexOf(id);
    if (index !== -1) {
      opened.value.splice(index, 1)
    }
  } else {
    opened.value.push(id)
  }
};

const scrollToForm = () => {
  const el = document.getElementById('feedbackForm');
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
</script>

<template>
  <div class="page">
    <div class="content">
      <Banner title="Франшиза по прокату авто от Мой Автопрокат" image="/img/main-bg-3.jpg" />
      <div class="container">
        <div class="content__wrapper">
          <BookingForm keep-alive />
          <div class="content__main">
            <div class="info">
              <h2 class="info__title title">Откройте свой автопрокат по франшизе за 30 дней! Возвращаем деньги, если «не пошло»! <br>Полный возврат денег за франшизу через год, если не отобьете вложений. Прописано в договоре.</h2>
              <div class="about__cards">
                <div class="about__card">
                  <div class="about__card-icon">
                    <img src="/img/icon-6.svg" alt="">
                  </div>
                  <div class="about__card-text small-text">
                    Открытие проката по франшизе за 30 дней
                  </div>
                </div>
                <div class="about__card">
                  <div class="about__card-icon">
                    <img src="/img/icon-7.svg" alt="">
                  </div>
                  <div class="about__card-text small-text">
                    Возврат денег за франшизу если она не окупится за 1 год.
                  </div>
                </div>
                <div class="about__card">
                  <div class="about__card-icon">
                    <img src="/img/icon-8.svg" alt="">
                  </div>
                  <div class="about__card-text small-text">
                    Доступно для любых регионов РФ.
                  </div>
                </div>
              </div>
            </div>
            <div class="about">
              <div class="about__text">
                <h2 class="title title-large center">Наша компания</h2>
                <div class="about__box">
                  <div class="about__box-item">
                    <p><strong>2014</strong></p>
                    <p>год основания</p>
                  </div>
                  <div class="about__box-item">
                    <p><strong>Москва</strong></p>
                    <p>штаб квартира</p>
                  </div>
                  <div class="about__box-item">
                    <p><strong>84%</strong></p>
                    <p>средняя загрузка парка в 2019 г.</p>
                  </div>
                  <div class="about__box-item">
                    <p><strong>30%</strong></p>
                    <p>Доля рынка в Крыму</p>
                  </div>
                  <div class="about__box-item">
                    <p><strong>28 человек</strong></p>
                    <p>в шатате</p>
                  </div>
                </div>
                <p class="small-text"><strong>Присутствие в регионах:</strong> Крым (Симферополь / Ялта / Евпатория); Сочи (Адлер) по франшизе;</p>
                <p class="small-text"><strong>Цель на 3 года:</strong> Построение федеральной сети прокатов под брендом Мой Автопрокат;</p>
                <p class="small-text"><strong>Примем</strong> в свой состав как новичков, так и действующие автопрокаты из любых регионов РФ.</p>
                <div class="about__gallery">
                  <div class="about__gallery-main">
                    <Swiper
                      class="swiper swiper-gallery"
                      :direction="'horizontal'"
                      :slides-per-view="2.14"
                      :space-between="16"
                      :loop="false"
                      :speed="600"
                      navigation
                      :modules="[Navigation, Thumbs]"
                      :thumbs="{ swiper: thumbsSwiper }"
                      :breakpoints="{ 761:{ slidesPerView: 1, spaceBetween: 0 } }"
                    >
                        <SwiperSlide>
                          <div class="about__gallery-item">
                            <img src="@/assets/img/gallery-1.jpg" alt="">
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div class="about__gallery-item">
                            <img src="@/assets/img/gallery-2.jpg" alt="">
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div class="about__gallery-item">
                            <img src="@/assets/img/gallery-3.jpg" alt="">
                          </div>
                        </SwiperSlide>
                    </Swiper>
                  </div>
                  <div class="about__gallery-thumbs">
                    <Swiper
                      class="swiper swiper-thumbs"
                      :centered-slides="true"
                      :centered-slides-bounds="true"
                      :slides-per-view="3"
                      :watch-overflow="true"
                      :watch-slides-progress="true"
                      :direction="'vertical'"
                      @swiper="setThumbsSwiper"
                    >
                        <SwiperSlide>
                          <div class="about__gallery-thumb">
                            <img src="@/assets/img/gallery-1.jpg" alt="">
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div class="about__gallery-thumb">
                            <img src="@/assets/img/gallery-2.jpg" alt="">
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div class="about__gallery-thumb">
                            <img src="@/assets/img/gallery-3.jpg" alt="">
                          </div>
                        </SwiperSlide>
                    </Swiper>
                  </div>
                </div>
                <div class="about__paragraph">
                  <h3 class="title title-small">Компания по прокату автомобилией Мой Автопрокат® (MyCarRental®)</h3>
                  <p class="small-text">Динамично развивающаяся компания, лидер в Крымском регионе. За 5 лет с полного нуля: свой парк 350 авто, круглосуточная стойка, парковка в аэропорту, свой автомоечный комплекс в аэропорту. Штат специалистов с огромным опытом, в т.ч. международным.</p>
                  <p class="small-text">Строим федеральную сеть прокатов по всей стране. Готовы делиться опытом и методиками ведения бизнеса. Обеспечим софтом и технологиями. Открыты для партнерства во всех регионах.</p>
                </div>
                <div class="about__form">
                  <div class="about__form-title title title-small">Получите бизнес-план для своего города прямо сейчас!</div>
                  <a class="button button-large button-accent" @click="scrollToForm"><span class="edit"></span> Заполните форму</a>
                </div>
              </div>
              <div class="faq">
                <div class="faq__title title center">Вопросы о компании</div>
                <div class="faq__content">
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(1)}" @click="toggle(1)">
                      <div class="faq__item-title">Почему бизнес в Крыму, а сами в Москве?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(1)}">
                      В Москве – управляющая компания, которая владеет торговым знаком и замыкает на себя важные процессы. Основной бизнес строим не только в Крыму, а по всей России. Первая точка по франшизе была открыта в конце 2019 года в Адлере (Сочи). 
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(2)}" @click="toggle(2)">
                      <div class="faq__item-title">Как Вы выросли до 350 авто?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(2)}">
                      На старте были инвесторские машины, но по прошествии 2 лет мы свели их число в паке к нулю и перешли к лизингу. Инвесторская машина освобождает от риска на старте. В долгосрочной перспективе – лизинг выгоднее, при условии, что взяли его с умом.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(3)}" @click="toggle(3)">
                      <div class="faq__item-title">Для чего вам в штате 28 человек, если не секрет?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(3)}">
                      Чтобы у вас в штате было мало человек, где-то их должно быть много. Мы замыкаем на себе ключевые процессы партнерских организаций, в том числе и Вашей, чтобы снизить нагрузку и повысить рентабельность. 
                    </div>
                  </div>
                </div>
              </div>
              <div class="about__text">
                <h2 class="title title-large center">Рынок аренды автомобилей</h2>
                <div class="about__box column">
                  <p class="small-text">Оказание услуг для командировок, отдыха и загородных поездок</p>
                  <p class="small-text">Растущая в России ниша (ежегодный темп прироста не менее 20%)</p>
                  <p class="small-text">Простота управления бизнесом, при должной подготовке</p>
                  <p class="small-text">Минимальный риск за счет высокой ликвидности активов</p>
                  <p class="small-text">Сравнительно небольшие инвестиции для запуска</p>
                  <p class="small-text">Прекрасный вариант для семейного бизнеса</p>
                </div>
                <p class="small-text">Подходит как для мегаполисов, так и для небольших городов.</p>
                <p class="small-text">Для управления полноценным бизнесом достаточно 2-3 сотрудников. Востребованная услуга и высокий потенциал роста. Бизнес интересен для инвесторов. Период окупаемости до трех лет.</p>
              </div>
              <div class="faq">
                <div class="faq__title title center">Вопросы по рынку автопроката в РФ</div>
                <div class="faq__content">
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(4)}" @click="toggle(4)">
                      <div class="faq__item-title">В каких городах не стоит открываться?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(4)}">
                      Спрос на транспорт есть в абсолютном большинстве регионов. Закрытие прокатов почти всегда вызвано не отсутствием спроса как такового, а высокими издержками, оптимизация которых возможна только в команде.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(5)}" @click="toggle(5)">
                      <div class="faq__item-title">Какова средняя цена аренды в сутки?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(5)}">
                      В финансовой модели для партнеров есть средние цены по разным классам машин. Чтобы получить готовую финансовую модель под интересующий вас город, обратитесь к нам через форму обратной связи. 
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(6)}" @click="toggle(6)">
                      <div class="faq__item-title">Что если клиент умышленно разбил авто?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(6)}">
                      Научим возмещать по суду вместе с компенсацией всех расходов.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(7)}" @click="toggle(7)">
                      <div class="faq__item-title">Сколько денег нужно для входа в нишу?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(7)}">
                      От 5 до 10 млн. рублей. Сильно зависит от оценки парка и способа покупки машин (свои / кредит / лизинг). Покупка парка – основная статья расходов на старте. Мы много внимания уделяем процессу закупки при обучении владельцев бизнеса.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(8)}" @click="toggle(8)">
                      <div class="faq__item-title">Почему вы сами не открываетесь в других городах?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(8)}">
                      Бизнес нужно вести там, где живешь. У нас не хватит рук и ресурсов открыть всё везде самим, мы же не онлайновый бизнес.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(9)}" @click="toggle(9)">
                      <div class="faq__item-title">Пугает конкуренция с каршерингом. Что можете сказать?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(9)}">
                      Зря пугает. Каршеринг и прокат не едят хлеб друг у друга. Скорее помогают, формируя привычку пользоваться чужим автомобилем. Целевая аудитория у каршеринга – местные, а у нас – приезжие. В Москве 24 тыс. каршеринговых машин заменяют 150 тыс. собственных авто у населения. И здравый смысл подсказывает, что впереди долгий восходящий тренд. Мы все на этой волне прокатимся.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(10)}" @click="toggle(10)">
                      <div class="faq__item-title">Дадите страховку от банкротства? :)</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(10)}">
                      Никто не застрахован от рисков предпринимательства, но ниша автопроката привлекательна тем, что все основные активы ликвидны. Что касается наших с вами отношений, в договоре есть гарантия возврата денег за франшизу через 12 месяцев.
                    </div>
                  </div>
                </div>
              </div>
              <div class="about__text">
                <h2 class="title title-large center">Что дает франшиза</h2>
                <div class="about__cards">
                  <div class="about__card large row">
                    <div class="about__card-icon">
                      <img src="/img/icon-9.svg" alt="">
                    </div>
                    <div class="about__card-content">
                      <div class="about__card-title title title-small">
                        Точный расчет и уверенность в действиях
                      </div>
                      <div class="about__card-text small-text">
                        Готовая бизнес-модель для парка от 10 до 100 машин. Расчет доходности / окупаемости инвестиций. Индивидуальный план развития со статьями доходов и структурой затрат. Обучаем и консультируем на всех этапах.
                      </div>
                    </div>
                  </div>
                  <div class="about__card large row">
                    <div class="about__card-icon">
                      <img src="/img/icon-10.svg" alt="">
                    </div>
                    <div class="about__card-content">
                      <div class="about__card-title title title-small">
                        Пошаговый план по запуску бизнеса
                      </div>
                      <div class="about__card-text small-text">
                        Все материалы для быстрого старта с минимумальными затратами. Правовая поддержка, управленческий учет, регламенты, инструкции. Все договора, акты, соглашения, шаблоны, письма, трудовые отношения и др.
                      </div>
                    </div>
                  </div>
                  <div class="about__card large row">
                    <div class="about__card-icon">
                      <img src="/img/icon-11.svg" alt="">
                    </div>
                    <div class="about__card-content">
                      <div class="about__card-title title title-small">
                        Система привлечения клиентов
                      </div>
                      <div class="about__card-text small-text">
                        Зарабатывайте с первых недель работы: готовый сайт, телефония, заказы, CRM система. Все, что необходимо наладить для управления бизнесом уже налажено. Получайте заказы с гарантией по договору.
                      </div>
                    </div>
                  </div>
                  <div class="about__card large row">
                    <div class="about__card-icon">
                      <img src="/img/icon-12.svg" alt="">
                    </div>
                    <div class="about__card-content">
                      <div class="about__card-title title title-small">
                        Право на использование товарного знака
                      </div>
                      <div class="about__card-text small-text">
                        Готовый бренд, локализованный под ваши потребности. Полный брендбук (цвета, шрифты, канцелярка, оформление). Клиенты любят Мой Автопрокат (средняя оценка 4.7 из 5). Наши клиенты – теперь и Ваши клиенты.
                      </div>
                    </div>
                  </div>
                  <div class="about__card large row">
                    <div class="about__card-icon">
                      <img src="/img/icon-13.svg" alt="">
                    </div>
                    <div class="about__card-content">
                      <div class="about__card-title title title-small">
                        Процессы описаны и автоматизированы
                      </div>
                      <div class="about__card-text small-text">
                        Сокращение расходов и минимизация ошибок за счет описания всех процессов: работа с клиентами, сотрудниками, безопасность, обслуживание парка и тд. Все скрипты адаптированы под Ваш регион и особенности парка.
                      </div>
                    </div>
                  </div>
                  <div class="about__card large row">
                    <div class="about__card-icon">
                      <img src="/img/icon-14.svg" alt="">
                    </div>
                    <div class="about__card-content">
                      <div class="about__card-title title title-small">
                        Лучшие мировые методики и практики
                      </div>
                      <div class="about__card-text small-text">
                        Отличный способ научиться правильному ведению бизнеса. Успешно работающая, проверенная система управления автопрокатом. Каждая машина должна находиться в аренде не менее 70% в месяц. Научим – как!
                      </div>
                    </div>
                  </div>
                </div>
                <p class="small-text">Приобретая франшизу Мой Автопрокат, Вы избегаете ошибок, свойственных новичкам, экономите время на создание рабочей модели бизнеса, оптимизируете все виды расходов; правильно мотивируете персонал; минимизируете налоги и выплаты, получаете готовую систему привлечения клиентов, таким образом – существенно экономите деньги на старте и в будущем.</p>
              </div>
              <div class="faq">
                <div class="faq__title title center">Вопросы по франшизе «Мой Автопрокат»</div>
                <div class="faq__content">
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(11)}" @click="toggle(11)">
                      <div class="faq__item-title">Зачем открываться по франшизе, если можно и без?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(11)}">
                      Чтобы получить экономию в 2-3 раза и не сделать ошибок на старте. С нами у вас все готово для старта через 30 дней, включая бесценный опыт, технологии, рекламу, маркетинг и знание секретов рынка.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(12)}" @click="toggle(12)">
                      <div class="faq__item-title">Поможете ли вы построить бизнес-план и фин. модель?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(12)}">
                      Да, это первый шаг после подписания договора. Выезжаем к вам и с полным погружением в местные особенности, делаем аудит рынка и составляем совместный бизнес-план.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(13)}" @click="toggle(13)">
                      <div class="faq__item-title">Кто будет регулировать цены на авто?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(13)}">
                      Цены на авто регулирует рынок. Задаете их Вы самостоятельно, но мы утверждаем на квартал, полгода и год вперед. Это наше право утверждать цены прописано в нашем с Вами договоре.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(14)}" @click="toggle(14)">
                      <div class="faq__item-title">На какой период заключается договор франшизы?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(14)}">
                      На 4 года. Если через 4 года у нас с вами нет претензий друг к другу по качеству работы, то договор автоматически продлевается.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(15)}" @click="toggle(15)">
                      <div class="faq__item-title">Какие гарантии вы даете?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(15)}">
                      Мы гарантируем полный возврат паушального взноса, если за 12 месяцев выручка (объем заказов) вашей компании будет меньше размера паушального взноса. Гарантия прописана в договоре.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(16)}" @click="toggle(16)">
                      <div class="faq__item-title">В каком объеме предоставляете правовую поддержку?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(16)}">
                      Наш юрист поможет учесть локальные нюансы во всех юридических аспектах на старте. При этом у нас есть большая судебная практика, которой мы готовы делиться с вами в ходе совместной операционной деятельности.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(17)}" @click="toggle(17)">
                      <div class="faq__item-title">Как будет синхронизироваться наличие автомобилей между сайтом и вашей CRM?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(17)}">
                      Если берете пакет "БРЕНД", то в ручном режиме. Пакет "СОФТ" и выше – автоматически.
                    </div>
                  </div>
                </div>
              </div>
              <div class="about__text">
                <h2 class="title title-large center">Кейс Адлер (Сочи)</h2>
                <div class="about__case">
                  <div class="about__case-block">
                    <div class="about__case-img">
                      <img src="/img/case-1.jpg" alt="">
                    </div>
                    <div class="about__case-content">
                      <p class="small-text">
                        <img src="/img/avatar.png" alt="">
                        Руслан Бочкарев работал под собственным брендом в Сочи на протяжении 6 лет. К моменту начала сотрудничества с нами в парке было 9 автомобилей Поло и Солярис (эконом-класс). Конкуренция вынуждала жёстко демпинговать и постоянно искать альтернативные решения. Думал уходить в другой бизнес.
                      </p>
                      <p class="small-text">В октябре 2019 Руслан приобрел франшизу Мой Автопрокат и стал нашим первым франчайзинг-партнером за пределами Крыма. Уже к концу ноября Руслан с нашей помощью расширил парк до 20 автомобилей эконом и комфорт класса.</p>
                      <p class="small-text">По состоянию на февраль 2020 года у Руслана в парке 25 автомобилей от эконома до бизнеса класса. К следующему году в планах взять рубеж в 40 автомобилей в парке. Загрузка по состоянию на февраль 2020 – 76%, что тоже очень неплохо.</p>
                    </div>
                  </div>
                  <div class="about__case-row">
                    <div class="about__case-block small">
                      <h3 class="title title-small">До франшизы:</h3>
                      <ul class="small-text">
                        <li>Автопарк 10 автомобилей</li>
                        <li>Заказы от посредников: 74%</li>
                        <li>Загрузка парка 01/2019: около 30%</li>
                        <li>Заявок в день: 1,7</li>
                        <li>Средний период аренды: 2,27 дней</li>
                      </ul>
                    </div>
                    <div class="about__case-block small">
                      <h3 class="title title-small">После франшизы:</h3>
                      <ul class="small-text">
                        <li>Автопарк 25 автомобилей</li>
                        <li>Заказы от посредников: 29%</li>
                        <li>Загрузка парка 01/2020: 76%</li>
                        <li>Заявок в день: 6,4</li>
                        <li>Средний период аренды: 4,91 дней</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="about__text">
                <h2 class="title title-large center">CRM система (пакет Софт)</h2>
                <p class="title large-text">CRM система от Мой Автопрокат — это программное решение на базе 1С, обеспечивающие собственнику учет, управление, оптимизацию всех процессов организации.</p>
                <p class="title large-text">Прозрачность и всесторонняя «прокачка» бизнеса.</p>
                <p class="title large-text">За годы работы мы учли в своей системе все нюансы прокатного бизнеса — удобство неоспоримо!</p>
                <div class="about__box column">
                  <p class="small-text">«Наши партнеры по пакетам „Софт“ и выше получают доступ к CRM-системе, позволяющей прокачать все процессы прокатного бизнеса. Наша CRM помогает автопрокату не просто вести учет, а расти и развиваться за счет правильно построенных бизнес процессов. Представьте, что у вас есть парк в 10 машин. Вести его учет в принципе можно и „на коленках“. Но когда задача — развиваться до парка в несколько сотен машин, то без правильной систематизации, которая контролирует и дисциплинирует, этого достичь невозможно. С нашей системой Вы сможете работать эффективно с самого старта.»</p>
                  <div class="about__box-row">
                    <div class="about__box-avatar">
                      <img src="/img/avatar-2.png" alt="">
                    </div>
                    <div class="about__box-row-wrapper">
                      <p class="small-text">Дмитрий Матвеев</p>
                      <p class="small-text"><span class="light-color">основатель Мой Автопрокат</span></p>
                    </div>
                  </div>
                </div>
                <h3 class="title center mb-more">Блоки, входящие в CRM «Мой Автопрокат»</h3>
                <div class="about__cards">
                  <div class="about__card large row">
                    <div class="about__card-icon">
                      <img src="/img/icon-15.svg" alt="">
                    </div>
                    <div class="about__card-content">
                      <div class="about__card-title title title-small">
                        Оперативный учет
                      </div>
                      <div class="about__card-text small-text">
                        В любое время, с компьютера или с телефона, вы имеете полноценный доступ ко всей информации о своем бизнесе.
                      </div>
                    </div>
                  </div>
                  <div class="about__card large row">
                    <div class="about__card-icon">
                      <img src="/img/icon-16.svg" alt="">
                    </div>
                    <div class="about__card-content">
                      <div class="about__card-title title title-small">
                        Бронирования
                      </div>
                      <div class="about__card-text small-text">
                        Все сделки в единой системе. Календарь занятости, интеграция с сайтом, доступ к заявкам, история и статусы бронирований, оптимизация загрузки и др.
                      </div>
                    </div>
                  </div>
                  <div class="about__card large row">
                    <div class="about__card-icon">
                      <img src="/img/icon-17.svg" alt="">
                    </div>
                    <div class="about__card-content">
                      <div class="about__card-title title title-small">
                        Сотрудники
                      </div>
                      <div class="about__card-text small-text">
                        Рабочее время, рабочие планы и графики, мотивация сотрудников. Настраиваемый функционал ролей. Воронка продаж, KPI и др.
                      </div>
                    </div>
                  </div>
                  <div class="about__card large row">
                    <div class="about__card-icon">
                      <img src="/img/icon-18.svg" alt="">
                    </div>
                    <div class="about__card-content">
                      <div class="about__card-title title title-small">
                        Документооборот
                      </div>
                      <div class="about__card-text small-text">
                        Все бланки документов и информация под рукой. Всю рутинную работу система выполняет за вас. Обработка заявок в 5-10 раз быстрее!
                      </div>
                    </div>
                  </div>
                  <div class="about__card large row">
                    <div class="about__card-icon">
                      <img src="/img/icon-19.svg" alt="">
                    </div>
                    <div class="about__card-content">
                      <div class="about__card-title title title-small">
                        Безопасность
                      </div>
                      <div class="about__card-text small-text">
                        Собственная круглосуточная служба безопасности. Всесторонняя проверка клиентов. Построение маршрутов авто за любой день. Полная отчетность по эксплуатации ТС. Дистанционная блокировка и др.
                      </div>
                    </div>
                  </div>
                  <div class="about__card large row">
                    <div class="about__card-icon">
                      <img src="/img/icon-20.svg" alt="">
                    </div>
                    <div class="about__card-content">
                      <div class="about__card-title title title-small">
                        Финансы
                      </div>
                      <div class="about__card-text small-text">
                        Контроль денежных средств. Платежный календарь, профилактика кассовых разрывов. Доходность в любых разрезах. Модуль ремонта и ТО. Контроль должников. Анализ загрузки автопарка и др.
                      </div>
                    </div>
                  </div>
                </div>
                <p class="small-text">Приобретая франшизу Мой Автопрокат, Вы избегаете ошибок, свойственных новичкам, экономите время на создание рабочей модели бизнеса, оптимизируете все виды расходов; правильно мотивируете персонал; минимизируете налоги и выплаты, получаете готовую систему привлечения клиентов, таким образом – существенно экономите деньги на старте и в будущем.</p>
              </div>
              <div class="faq">
                <div class="faq__title title center">Вопросы по CRM системе</div>
                <div class="faq__content">
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(18)}" @click="toggle(18)">
                      <div class="faq__item-title">Это система управления отношениями с клиентами (Client Relations Management). В нашем случае – программа, в которой максимально оптимизирован учет автопроката на территории РФ.</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(18)}">
                      Залог блокируется на карте и возвращается Вашим банком в течение 30 дней.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(19)}" @click="toggle(19)">
                      <div class="faq__item-title">Есть ли возможность тест драйва (опробовать CRM систему, тест СБ)?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(19)}">
                      В разумных пределах покажем, продемонстрируем. Но начинаем работу по обучению работе c ней партнера только после подписание договора франшизы.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(20)}" @click="toggle(20)">
                      <div class="faq__item-title">Могу ли я просто периодически пользоватся вашей СБ?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(20)}">
                      Нет. Тут есть юридические нюансы, связанные с обработкой личных данных, так что наша СБ обслуживает только компании, входящие в группу "Мой автопрокат".
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(21)}" @click="toggle(21)">
                      <div class="faq__item-title">Что, если Ваша СБ пропустила клиента, а он угнал авто?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(21)}">
                      Мы уверены в своей СБ как в самих себе, но мы не видим клиента вживую, так что последнее решение всегда за менеджером, выдающим авто. В ходе обучения сотрудников, уделим особое внимание тому, как распознать плохих арендаторов.
                    </div>
                  </div>
                </div>
              </div>
              <div class="about__text">
                <h2 class="title title-large center">Маркетинг (Пакет «Реклама»)</h2>
                <h3 class="title">Быстрый старт заказов</h3>
                <p class="small-text">Налаженная система привлечения клиентов. Полное сопровождение по всем каналам бронирования. Эффективный маркетинг-план, позволяющий оптимизировать затраты на рекламу и привести большое количество клиентов за меньшие деньги. Настроим аналитику. Первичная рекламная кампания и бюджет на SEO-раскрутку уже включены в паушальный взнос!</p>
                <div class="about__info">
                  <div class="about__info-cards">
                    <div class="about__info-card small">
                      <div class="about__info-card-img large">
                        <img src="/img/img-1.jpg" alt="">
                      </div>
                      <div class="about__info-card-content">
                        <p class="about__info-card-subtitle">Единый сайт</p>
                        <p class="about__info-card-text">Простота бронирования. Узнаваемый бренд. Понятные условия. Отличная конверсия из посетителя в заказ. Единый сайт для всех регионов. Вся боль на IT поддержке лежит на нас.</p>
                      </div>
                    </div>
                    <div class="about__info-card small">
                      <div class="about__info-card-img large">
                        <img src="/img/img-2.jpg" alt="">
                      </div>
                      <div class="about__info-card-content">
                        <p class="about__info-card-subtitle">Контекстная реклама</p>
                        <p class="about__info-card-text">Оптимальная контекстная реклама для Вашего региона в Яндекс и Google. Мы накопили огромный опыт в контексте, позволяющий в разы оптимизировать рекламный бюджет.</p>
                      </div>
                    </div>
                    <div class="about__info-card small">
                      <div class="about__info-card-img large">
                        <img src="/img/img-3.jpg" alt="">
                      </div>
                      <div class="about__info-card-content">
                        <p class="about__info-card-subtitle">Агрегаторы / брокеры</p>
                        <p class="about__info-card-text">Новый франчайзи будет доступен на сайтах всех известных брокеров. Персональный менеджер загрузит парк и удержит ТОП на популярных площадках.</p>
                      </div>
                    </div>
                    <div class="about__info-card small">
                      <div class="about__info-card-img large">
                        <img src="/img/img-4.jpg" alt="">
                      </div>
                      <div class="about__info-card-content">
                        <p class="about__info-card-subtitle">Email рассылка</p>
                        <p class="about__info-card-text">35000 клиентов регулярно получают от нас email со спец. предложениями. Пришло время им узнать, что Вы с нами!</p>
                      </div>
                    </div>
                    <div class="about__info-card small">
                      <div class="about__info-card-img large">
                        <img src="/img/img-5.jpg" alt="">
                      </div>
                      <div class="about__info-card-content">
                        <p class="about__info-card-subtitle">SEO оптимизация</p>
                        <p class="about__info-card-text">Точечное SEO продвижение страниц по вашему региону. Топ-10 Яндекса по сотням целевых запросов уже сегодня!</p>
                      </div>
                    </div>
                    <div class="about__info-card small">
                      <div class="about__info-card-img large">
                        <img src="/img/img-6.jpg" alt="">
                      </div>
                      <div class="about__info-card-content">
                        <p class="about__info-card-subtitle">Каталоги и карты</p>
                        <p class="about__info-card-text">Приоритетное размещение в картах, каталогах, справочниках. Размещение в тематических досках объявлений.</p>
                      </div>
                    </div>
                    <div class="about__info-card small">
                      <div class="about__info-card-img large">
                        <img src="/img/img-7.jpg" alt="">
                      </div>
                      <div class="about__info-card-content">
                        <p class="about__info-card-subtitle">SMM / социальные сети</p>
                        <p class="about__info-card-text">Оформление и развитие аккаунтов в социальных сетях. Промокоды и аффилиатка с известными блогерами.</p>
                      </div>
                    </div>
                    <div class="about__info-card small">
                      <div class="about__info-card-img large">
                        <img src="/img/img-8.jpg" alt="">
                      </div>
                      <div class="about__info-card-content">
                        <p class="about__info-card-subtitle">Оффлайн / Наружка</p>
                        <p class="about__info-card-text">Фирменный стиль и набор готовой рекламной полиграфии. Инструкции по изготовлению печатной рекламы.</p>
                      </div>
                    </div>
                    <div class="about__info-card small">
                      <div class="about__info-card-img large">
                        <img src="/img/img-9.jpg" alt="">
                      </div>
                      <div class="about__info-card-content">
                        <p class="about__info-card-subtitle">Партнерские кабинеты</p>
                        <p class="about__info-card-text">Имеем большой опыт сотрудничества с отелями, страховыми и тур. компаниями. Обучим лучшим скриптам.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="about__cards">
                  <div class="about__card large left">
                    <div class="about__card-title title title-small">
                      Бюджет на контекст и SEO уже включены!
                    </div>
                    <div class="about__card-text small-text">
                      Соцсети, каталоги, справочники включены в пакет «Реклама»
                    </div>
                  </div>
                  <div class="about__card large left accent">
                    <div class="about__card-title title title-small">
                      Обсудим <br>финмодель?
                    </div>
                    <a href="javascript:void(0)" class="about__card-link small-text"><span class="phone-icon"></span> <span class="line">Позвонить</span></a>
                  </div>
                </div>
              </div>
              <div class="faq">
                <div class="faq__title title center">Частые вопросы по рекламе и маркетингу</div>
                <div class="faq__content">
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(22)}" @click="toggle(22)">
                      <div class="faq__item-title">Будет ли у меня доступ к рекламной компании для редактирования и управления?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(22)}">
                      Будет, если необходим.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(23)}" @click="toggle(23)">
                      <div class="faq__item-title">Кто такой менеджер по работе с агрегаторами?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(23)}">
                      Специалист, который помогает вам разбираться в тонкостях работы с конкретным агрегатором и регулярно проверяет присутствие в выдаче топ-3 результатов на нем. Один этот сотрудник способен обеспечить до 30% загрузки в каждом классе.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(24)}" @click="toggle(24)">
                      <div class="faq__item-title">Чем мне поможет Ваша рассылка?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(24)}">
                      В России есть определенный процент целевой платежеспособной аудитории, который арендует автомобили, у нас есть имейлы существенной доли этой аудитории. Им обязательно нужно знать о том, что вы теперь с нами. Конверсия этого канала остается самой высокой.
                    </div>
                  </div>
                </div>
              </div>
              <div class="about__text">
                <h2 class="title title-large center">Чему мы вас научим?</h2>
                <h3 class="title title-small"><strong>Обучение и сопровождение на всех этапах</strong></h3>
                <p class="small-text">Получите поддержку по всем организационным и операционным вопросам напрямую от топ-менеджмента на весь период действия договора.</p>
                <div class="about__cards">
                  <div class="about__card light">
                    <div class="about__card-icon">
                      <img src="/img/icon-21.svg" alt="">
                    </div>
                    <div class="about__card-title small-text">
                      <strong>Стратегия развития</strong>
                    </div>
                    <div class="about__card-text small">
                      Цели, выручка, затраты
                    </div>
                  </div>
                  <div class="about__card light">
                    <div class="about__card-icon">
                      <img src="/img/icon-22.svg" alt="">
                    </div>
                    <div class="about__card-title small-text">
                      <strong>Работа с CRM системой</strong>
                    </div>
                    <div class="about__card-text small">
                      С выездом к вам специалиста
                    </div>
                  </div>
                  <div class="about__card light">
                    <div class="about__card-icon">
                      <img src="/img/icon-23.svg" alt="">
                    </div>
                    <div class="about__card-title small-text">
                      <strong>Мануалы, скрипты</strong>
                    </div>
                    <div class="about__card-text small">
                      Подробные руководства
                    </div>
                  </div>
                  <div class="about__card light">
                    <div class="about__card-icon">
                      <img src="/img/icon-24.svg" alt="">
                    </div>
                    <div class="about__card-title small-text">
                      <strong>Формирование парка</strong>
                    </div>
                    <div class="about__card-text small">
                      Оптимальный модельный ряд
                    </div>
                  </div>
                  <div class="about__card light">
                    <div class="about__card-icon">
                      <img src="/img/icon-25.svg" alt="">
                    </div>
                    <div class="about__card-title small-text">
                      <strong>Ценообразование</strong>
                    </div>
                    <div class="about__card-text small">
                      Системы "эффективной" цены
                    </div>
                  </div>
                  <div class="about__card light">
                    <div class="about__card-icon">
                      <img src="/img/icon-26.svg" alt="">
                    </div>
                    <div class="about__card-title small-text">
                      <strong>Мотивация персонала</strong>
                    </div>
                    <div class="about__card-text small">
                      KPI и бонусы сотрудников
                    </div>
                  </div>
                  <div class="about__card light">
                    <div class="about__card-icon">
                      <img src="/img/icon-27.svg" alt="">
                    </div>
                    <div class="about__card-title small-text">
                      <strong>Служба безопасности</strong>
                    </div>
                    <div class="about__card-text small">
                      Проверка, GPS, форс-мажоры
                    </div>
                  </div>
                  <div class="about__card light">
                    <div class="about__card-icon">
                      <img src="/img/icon-28.svg" alt="">
                    </div>
                    <div class="about__card-title small-text">
                      <strong>Продвижение бизнеса</strong>
                    </div>
                    <div class="about__card-text small">
                      Все возможности в отрасли
                    </div>
                  </div>
                  <div class="about__card light">
                    <div class="about__card-icon">
                      <img src="/img/icon-29.svg" alt="">
                    </div>
                    <div class="about__card-title small-text">
                      <strong>Финансовый учет</strong>
                    </div>
                    <div class="about__card-text small">
                      Оптимизация расходов
                    </div>
                  </div>
                </div>
              </div>
              <div class="faq">
                <div class="faq__title title center">Вопросы по обучению и сопровождению</div>
                <div class="faq__content">
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(25)}" @click="toggle(25)">
                      <div class="faq__item-title">Где территориально проходит обучение для владельцев бизнеса?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(25)}">
                      У вас на рабочем месте. Мы прилетаем, обучаем. Требуется 3 дня по 5 часов. Обучение владельцев входит во все пакеты франшизы Мой Автопрокат.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(26)}" @click="toggle(26)">
                      <div class="faq__item-title">Как проходит обучение работе с CRM системой?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(26)}">
                      Очно, у вас в офисе в процессе запуска или сразу после. Обучение занимает 4 дня. Оптимально – до пяти сотрудников на старте. Доступно для тех, кто приобрел пакет "Софт" и выше. 
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(27)}" @click="toggle(27)">
                      <div class="faq__item-title">Формирование парка: что если машины уже есть?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(27)}">
                      Если парк уже сформирован, то проведем аудит и внесем изменения, если требуется.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(28)}" @click="toggle(28)">
                      <div class="faq__item-title">Ценообразование: как вы формируете свою цену?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(28)}">
                      Мы не формируем цену за вас, а утверждаем предложенные вами. Но для этого нужно научиться формировать цены с оглядкой на среднерыночные и загрузку парка у себя и у конкурентов. Данные получаем с рынка. Научим – как.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(29)}" @click="toggle(29)">
                      <div class="faq__item-title">KPI сотрудников — что это?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(29)}">
                      Количественные показатели деловой активности сотрудников, подразделений и компании в целом. 
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(30)}" @click="toggle(30)">
                      <div class="faq__item-title">Как ваша служба безопасности проверяет клиентов?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(30)}">
                      СБ – это физические сотрудники, которые имеют доступ к большому количеству данных о клиентах физ. лицах. Они проверяют данные по клиентам в круглосуточном режиме. Общение с ними вами напрямую не осуществляется. Заявка на проверку отправляется из CRM системы. На выходе получаем рекомендацию – выдать авто клиенту или нет.
                    </div>
                  </div>
                </div>
              </div>
              <div class="about__text">
                <h2 class="title title-large center">Пакеты франшиз Мой Автопрокат</h2>
                <div class="table">
                  <div class="table__head">
                    <div class="table__name small-text"><strong>Программы сотрудничества</strong></div>
                    <div class="table__name small">БРЕНД</div>
                    <div class="table__name small">СОФТ</div>
                    <div class="table__name small">РЕКЛАМА</div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">Стратегия развития с ТОП-менеджментом</div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">Право на торговый знак</div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">Эксклюзивность в регионе</div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">Локализованный брендбук</div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">Сайт с поддержкой</div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">Ежемесячная рассылка</div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">Колл-центр 8-800</div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">Пакет документов</div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">CRM система</div>
                    <div class="table__value icon icon-minus"></div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">Обучение сотрудников работе с CRM системой</div>
                    <div class="table__value icon icon-minus"></div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">Служба безопасности</div>
                    <div class="table__value icon icon-minus"></div>
                    <div class="table__value icon icon-check"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">Маркетинговое сопровождение</div>
                    <div class="table__value icon icon-minus"></div>
                    <div class="table__value icon icon-minus"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">SEO продвижение по вашему региону</div>
                    <div class="table__value icon icon-minus"></div>
                    <div class="table__value icon icon-minus"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">Контекстная реклама: разработка, ведение, бюджет</div>
                    <div class="table__value icon icon-minus"></div>
                    <div class="table__value icon icon-minus"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">Персональный менеджер по работе с брокерами</div>
                    <div class="table__value icon icon-minus"></div>
                    <div class="table__value icon icon-minus"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">Размещение в картах и справочниках</div>
                    <div class="table__value icon icon-minus"></div>
                    <div class="table__value icon icon-minus"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__row">
                    <div class="table__value small-text">Социальные сети – оформление и ведение</div>
                    <div class="table__value icon icon-minus"></div>
                    <div class="table__value icon icon-minus"></div>
                    <div class="table__value icon icon-check"></div>
                  </div>
                  <div class="table__bottom">
                    <div class="table__row">
                      <div class="table__name small-text"><strong>Паушальный взнос</strong></div>
                      <div class="table__name small-text"><strong>1 млн.</strong></div>
                      <div class="table__name small-text"><strong>2 млн.</strong></div>
                      <div class="table__name small-text"><strong>3 млн.</strong></div>
                    </div>
                    <div class="table__row">
                      <div class="table__name small-text"><strong>Ежемесячный роялти от оборота</strong></div>
                      <div class="table__name small-text"><strong>2%</strong></div>
                      <div class="table__name small-text"><strong>3%</strong></div>
                      <div class="table__name small-text"><strong>5%</strong></div>
                    </div>
                  </div>
                  <div class="table__text">
                    <p class="small-text"><strong>Паушальный взнос</strong></p>
                    <p class="small-text">Пакет "БРЕНД" - 1 млн. руб.; пакет "СОФТ" - 2 млн. руб.; пакет "РЕКЛАМА" - 3 млн. руб. Оплачивается при заключении договора.</p>
                  </div>
                  <div class="table__text">
                    <p class="small-text"><strong>Роялти платеж</strong></p>
                    <p class="small-text">От 2 до 5% оборота в месяц в зависимости от пакета. Оплачивается с 4-го месяца работы.</p>
                  </div>
                  <div class="table__block title title-small">
                    Паушальный взнос и роялти могут варьироваться в зависимости от региона. Условия обсуждаются индивидуально!
                  </div>
                </div>
              </div>
              <div class="faq">
                <div class="faq__title title center">Вопросы по пакетам франшизы</div>
                <div class="faq__content">
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(31)}" @click="toggle(31)">
                      <div class="faq__item-title">Могу ли я приобрести пакет СОФТ + отдельно заказать у вас SEO продвижение по своему городу? Какова цена?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(31)}">
                      Мы не приветствуем расщепление пакетов, так как уже собрали в систему конкретные проверенные алгоритмы.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(32)}" @click="toggle(32)">
                      <div class="faq__item-title">На какой срок включена контекстная реклама в пакете "Реклама"?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(32)}">
                      Включено столько кликов, сколько необходимо для оптимизации настроек по конкретному региону. В среднем период "расклика" занимает от 2 до 5 месяцев (в зависимости от региона и конкуренции). На этот срок контекстная реклама вам обеспечена.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(33)}" @click="toggle(33)">
                      <div class="faq__item-title">Маркетинговое сопровождение – что это и сколько по времени включено?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(33)}">
                      Безлимитные консультации по онлайн-маркетингу в течение всего времени сотрудничества.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(34)}" @click="toggle(34)">
                      <div class="faq__item-title">Если сразу после покупки Франшизы я захочу продать бизнес, возможно ли сохранить ваш пакет для покупателя?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(34)}">
                      Передаваемый по договору Комплекс исключительных прав остается на юридическом лице, если оно продолжает осуществлять свою деятельность
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(35)}" @click="toggle(35)">
                      <div class="faq__item-title">Почему роялти платеж зависит от выбранного пакета?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(35)}">
                      Чем более полный пакет вы приобретаете, тем больше от нас требуется делать на протяжении периода сотрудничества (базовый период действия контракта 4 года). Роялти платеж измеряется в процентах от оборота. Мы очень заинтересованы в том, чтобы его максимизировать.
                    </div>
                  </div>
                  <div class="faq__item">
                    <div class="faq__item-head" :class="{active: opened.includes(36)}" @click="toggle(36)">
                      <div class="faq__item-title">Цены и условия пакетов зависят от региона?</div>
                      <div class="faq__item-btn"></div>
                    </div>
                    <div class="faq__item-content" :class="{active: opened.includes(36)}">
                      Да, если спрос на услугу аренды авто в конкретном регионе сильно ограничен, то мы пересмотрим базовые условия на индивидуальные.
                    </div>
                  </div>
                </div>
              </div>
              <FeedbackFormFranchise id="feedbackForm" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>